import requests from "./httpService";

const CashEntryServices = {
  // Fetch server-based date limits: today and yesterday in IST.
   getEntryDateWindow: async (passbookId) => {
    const query = passbookId
      ? `?passbookId=${encodeURIComponent(passbookId)}`
      : "";

    return requests.get(
      `/site-cash-entries/date-window${query}`
    );
  },

  // Upload two images or one PDF for a single entry row.
  uploadAttachments: async (files) => {
    const formData = new FormData();

    Array.from(files || []).forEach((file) => {
      formData.append("attachments", file);
    });

    return requests.post(
      "/site-cash-entries/attachments",
      formData
    );
  },

  // CashMaker submits multiple entry rows.
  createCashEntries: async (body) => {
    return requests.post("/site-cash-entries", body);
  },

  // Fetch entries using optional filters.
 getCashEntries: async (filters = {}) => {
  const params = new URLSearchParams();

  [
    "storeId",
    "passbookId",
    "entryType",
    "status",
    "pendingOnly"
  ].forEach((key) => {
    const value = filters[key];

    if (
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      params.set(key, String(value));
    }
  });

  const query = params.toString();

  return requests.get(
    `/site-cash-entries${query ? `?${query}` : ""}`
  );
},

  // CashChecker approves or rejects an entry.
  reviewByAdmin: async (id, body) => {
    return requests.patch(
      `/site-cash-entries/${encodeURIComponent(id)}/admin-review`,
      body
    );
  },

  // Accounts approves or rejects an entry.
  reviewByAccounts: async (id, body) => {
    return requests.patch(
      `/site-cash-entries/${encodeURIComponent(id)}/accounts-review`,
      body
    );
  },

    requestAmendment: async (entryId, body) => {
    return requests.post(
      `/site-cash-entries/${encodeURIComponent(entryId)}/amendments`,
      body
    );
  },

  getAmendments: async (filters = {}) => {
    const params = new URLSearchParams();

    ["entryId", "passbookId", "status", "page", "limit"].forEach(
      (key) => {
        const value = filters[key];

        if (
          value !== undefined &&
          value !== null &&
          value !== ""
        ) {
          params.set(key, String(value));
        }
      }
    );

    const query = params.toString();

    return requests.get(
      `/site-cash-entries/amendments${query ? `?${query}` : ""}`
    );
  },

  reviewAmendment: async (id, body) => {
    return requests.patch(
      `/site-cash-entries/amendments/${encodeURIComponent(id)}/review`,
      body
    );
  },

  requestDateAccess: async (body) => {
    return requests.post(
      "/site-cash-entries/date-access",
      body
    );
  },

  getDateAccessRequests: async (filters = {}) => {
    const params = new URLSearchParams();

    ["passbookId", "status", "page", "limit"].forEach((key) => {
      const value = filters[key];

      if (
        value !== undefined &&
        value !== null &&
        value !== ""
      ) {
        params.set(key, String(value));
      }
    });

    const query = params.toString();

    return requests.get(
      `/site-cash-entries/date-access${query ? `?${query}` : ""}`
    );
  },

  reviewDateAccess: async (id, body) => {
    return requests.patch(
      `/site-cash-entries/date-access/${encodeURIComponent(id)}/review`,
      body
    );
  },

  // Accounts activates or deactivates a passbook.
  updatePassbookStatus: async (id, status) => {
    return requests.patch(
      `/site-cash-passbooks/${encodeURIComponent(id)}/status`,
      { status }
    );
  },

  resubmitReturnedCashOut: async (id, body) => {
  return requests.patch(
    `/site-cash-entries/${encodeURIComponent(id)}/resubmit`,
    body
  );
},

acceptRejection: async (id) => {
  return requests.patch(
    `/site-cash-entries/${encodeURIComponent(id)}/accept-rejection`,
    {}
  );
},

// CashMaker sends an unaccepted rejected entry for approval again.
reprocessRejectedEntry: async (id, body) => {
  return requests.patch(
    `/site-cash-entries/${encodeURIComponent(id)}/reprocess-rejection`,
    body
  );
},


resubmitReturnedCashIn: async (id, body) => {
  return requests.patch(
    `/site-cash-entries/${encodeURIComponent(id)}/resubmit`,
    body
  );
},
};

export default CashEntryServices;